import { Modal, Select } from 'antd'
import Notiflix from 'notiflix';
import { useEffect, useState } from 'react'
import PhoneInput from 'react-phone-number-input'
import PostApiCall from '../Api/PostApi';
import { parsePhoneNumber } from 'react-phone-number-input'
import en from 'react-phone-number-input/locale/en.json'
import "./LodhaForm.css"

const LeadsDeleteModal = ({ isDeleteOpen, handleCloseDeleteModal, selectedData = {} }) => {



	const DeleteVisitorLeadDetails = async () => {
		Notiflix.Loading.dots("Please Wait...");
		PostApiCall.postRequest(
			{
				leadDetailId: selectedData?.fld_id || null,
			},
			"DeleteVisitorLeadDetails"
		).then((result) =>
			result.json().then((obj) => {
				if (result.status == 200 || result.status == 201) {
					Notiflix.Notify.success("Details Deleted Succesfully");
					Notiflix.Loading.remove();
					handleCloseDeleteModal('fetch');

				}
			})
		);
	}


	return (
		<>
			<Modal
				centered
				width={700}
				open={isDeleteOpen}
				onOk={() => handleCloseDeleteModal()}
				onCancel={() => handleCloseDeleteModal()}
				footer={false}>
				<div className="row landing-page-modal">
					<div className="col-lg-12">
						<div className="p-3 w-100 visitorformbg bg-white lodha-form">
							<div className='mb-3'>
								<h2 className="mb-2">Delete</h2>
								<p>This action cannot be undone. Are you sure you want to delete these details ? </p>
							</div>



							<div className="mt-1 mb-0 mb-sm-1 pb-1 pb-sm-1 align-self-sm-end d-flex justify-content-start gap-2">
								<button
									type="button"
									className="visitor-btn"
									onClick={() => handleCloseDeleteModal()}
								>

									Cancel
								</button>
								<button
									type="button"
									className="visitor-btn"
									onClick={() => DeleteVisitorLeadDetails()}
								>
									Confirm And Delete
								</button>
							</div>
						</div>
					</div>
				</div>
			</Modal>
		</>
	)
}

export default LeadsDeleteModal